import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Separator } from '@/components/ui/separator';
import { Wallet, Save, CheckCircle2, XCircle } from 'lucide-react';

export function StripeConfigCard({ stripeConfig, setStripeConfig, onSave, saving }) {
  return (
    <Card className="border-border bg-card">
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle className="text-lg flex items-center gap-2" style={{ fontFamily: 'Manrope' }}>
              <Wallet className="w-5 h-5 text-purple-500" />
              Configurazione Stripe Pagamenti
              {stripeConfig.configured ? (
                <span className="ml-2 flex items-center text-xs text-green-500">
                  <CheckCircle2 className="w-3 h-3 mr-1" /> Configurato
                </span>
              ) : (
                <span className="ml-2 flex items-center text-xs text-yellow-500">
                  <XCircle className="w-3 h-3 mr-1" /> Non configurato
                </span>
              )}
            </CardTitle>
            <CardDescription>
              Configura Stripe per i pagamenti reali degli abbonamenti e ticket extra
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="space-y-2">
          <Label>Secret Key Stripe *</Label>
          <Input
            data-testid="stripe-secret-key"
            type="password"
            placeholder={stripeConfig.stripe_secret_key_set ? 'sk_****••••' : 'sk_live_... o sk_test_...'}
            value={stripeConfig.stripe_secret_key.startsWith('sk_****') ? '' : stripeConfig.stripe_secret_key}
            onChange={(e) => setStripeConfig({ ...stripeConfig, stripe_secret_key: e.target.value })}
          />
          <p className="text-xs text-muted-foreground">
            Trova la tua Secret Key nel dashboard Stripe: Dashboard → Developers → API Keys
          </p>
        </div>

        <div className="space-y-2">
          <Label>Publishable Key Stripe (opzionale)</Label>
          <Input
            data-testid="stripe-publishable-key"
            placeholder="pk_live_... o pk_test_..."
            value={stripeConfig.stripe_publishable_key || ''}
            onChange={(e) => setStripeConfig({ ...stripeConfig, stripe_publishable_key: e.target.value })}
          />
        </div>

        <div className="p-3 bg-muted/30 rounded-lg border border-border">
          <p className="text-sm text-muted-foreground">
            <strong>Modalita' Test:</strong> Usa chiavi che iniziano con <code className="text-xs bg-background px-1 rounded">sk_test_</code> per testare i pagamenti senza addebiti reali.
          </p>
        </div>

        <Separator />

        <Button
          onClick={onSave}
          disabled={saving}
          data-testid="save-stripe-config"
          className="bg-primary text-primary-foreground hover:bg-primary/90"
        >
          <Save className="w-4 h-4 mr-2" />
          {saving ? 'Salvataggio...' : 'Salva Configurazione Stripe'}
        </Button>
      </CardContent>
    </Card>
  );
}
